"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StructPropBuilder_1 = require("../../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../../core/model/DomainObject");

var utils_1 = require("../../../core/utils");
/**
 * Sellout impact attributes (LOG-3103). Since PROFACT-312 it contains 3 dimensions (releaseId, categoryId and reopen)
 * to identify impact record.
 *
 * @author Radek Beran
 * @author JMr
 * @author Jan Prokop
 */


var SelloutImpactRecord =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(SelloutImpactRecord, _DomainObject_1$Domai);

  /**
   * Creates new record of sellout impact report.
   *
   * @param id unique id of impact record
   * @param releaseId release id
   * @param categoryId category id
   * @param reopen If the impact record is for previous values (previous release openings), this is the sequence number of the opening
   * (0 = initial open). It is null (or omitted in document), if the impact record is for the current values.
   * @param selloutProductsCount (No. of sellout products; aggregation: sum) number of products within given
   * sellout release type (not-readonly items); regardless of Exported flag
   * @param sitesCount (aggregation: set union, in final step number of items in the set)
   * no. of unique sites across all products (LOG-4985)
   * @param priceChangesCount (No. of Price changes; aggregation: sum) total number of price changes
   * (price changes are counted for a product per site).
   * @param discountPercent (Discount; aggregation: average) average discount in percent
   * (see {@link SelloutReleaseItemPrices.discountPercent})
   * @param marginOld (Old margin; aggregation: sum)
   * @param marginOldPercent (Old margin; aggregation: weighted average)
   * @param marginNew (New margin; aggregation: sum)
   * @param marginNewPercent (New margin; aggregation: weighted average) weighted average of new margin for
   * new (final) price (weighted by new forecast)
   * @param marginChange (Margin change; aggregation: sum - LOG-4813)
   * (see {@link SelloutReleaseItemPrices.marginChange})
   * @param marginChangePercent (Margin change; aggregation: average) average change of margin in percent
   * (see {@link SelloutReleaseItemPrices.marginChangePercent})
   * @param profitOld (Old profit in CZK; aggregation: sum), computed as regular price - purchase price
   * @param profitOldPercent (Old profit in %; aggregation: weighted average) (weighted by old forecast)
   * (see {@link SelloutReleaseItemPrices.profitOldPercent})
   * @param profitNew (New profit in CZK; aggregation: sum), computed as final price - purchase price
   * @param profitNewPercent (New profit in %; aggregation: weighted average) (weighted by new forecast)
   * (see {@link SelloutReleaseItemPrices.profitNewPercent})
   * @param profitImpact (Profit impact; aggregation: sum - LOG-4813)
   * (see {@link SelloutReleaseItemPrices.profitImpact})
   * @param profitImpactPercent (Profit impact in %; aggregation: average)
   * (see {@link SelloutReleaseItemPrices.profitImpactPercent})
   * @param minPriceChangeInPercent (Min % price change; aggregation: average) average minimal price change in percent
   * (see {@link SelloutReleaseItem.minPriceChangeInPercent})
   * @param maxPriceChangeInPercent (Min % price change; aggregation: average) average minimal price change in percent
   * (see {@link SelloutReleaseItem.maxPriceChangeInPercent})
   * @param minMarginChangeInPercent (Min % margin; aggregation: average) average minimal margin change limit in percent
   * (see {@link SelloutReleaseItem.minMarginChangeInPercent})
   * @param availableSupplyPrice (Sellout stock value; aggregation: sum) sum of available supply expressed in CZK
   * (see {@link SelloutReleaseItemSupplyData.availableSupply})
   * Purchase price value should be used to compute value in CZK
   * @param availableSupply (Sellout stock volume; aggregation: sum) sum of available supply expressed in units
   * (see {@link SelloutReleaseItemSupplyData.availableSupply})
   * @param availableSupplyBeforeRepricingPrice (Initial sellout stock value; aggregation: sum) sum of available supply before repricing
   * expressed in CZK (see {@link SelloutReleaseItemSupplyData.availableSupplyBeforeRepricing})
   * Purchase price value should be used to compute value in CZK
   * @param availableSupplyBeforeRepricing (Initial sellout stock volume; aggregation: sum) sum of available supply before repricing
   * expressed in units (see {@link SelloutReleaseItemSupplyData.availableSupplyBeforeRepricing})
   * @param availableSupplyPriceChange (Sellout stock value change; aggregation: sum) sum of differences of available supply price
   * and available supply price before repricing expressed in CZK
   * @param availableSupplyChange (Sellout stock volume change; aggregation: sum) sum of differences of available supply and available
   * supply before repricing expressed in CZK
   * @param availableSupplyPriceChangePercent (Sellout stock value change in %; aggregation: sum)
   * availableSupplyPriceChange / availableSupplyPriceBeforeRepricing as %
   * @param availableSupplyChangePercent (Sellout stock volume change; aggregation: sum)
   * availableSupplyChange / availableSupplyBeforeRepricing as %
   * @param deadstockProvisionDiscountPercent (Deadstock provision discount; aggregation: average)
   * average of {@link SelloutReleaseItemPrices.deadstockProvisionDiscountPercent}; filled only for deadstock release type
   * @param deadstockProvision (Deadstock provision; aggregation: average) average of {@link SelloutReleaseItemPrices.deadstockProvision};
   * filled only for deadstock release type
   * @param deadstockInvestment (Deadstock Investment [CZK]; aggregation: average) average of
   * {@link SelloutReleaseItemPrices.deadstockInvestment};
   * filled only for deadstock release type
   * @param deadstockImpact (Deadstock Impact [CZK]; aggregation: average) average of (deadstockInvestment + deadstockProvision) values
   * filled only for deadstock release type
   * @param estimationInPercent (Current estimation [%]; aggregation? average) average
   * of {@link SelloutReleaseItemEvaluation.estimationInPercent}
   * @param salesVolumeOld (time dependent; aggregation: sum) oldForecast from Yieldigo (expected regular sold amount
   * in unit (kg, ks, ...) for current regular price, for final price validity interval - to be time-comparable
   * with salesVolumeNew).
   * @param salesVolumeNew (time dependent; aggregation: sum) newForecast from Yieldigo (expected regular sold amount
   * in unit (kg, ks, ...) for new final price, for final price validity interval)
   * @param revenueOld (time dependent; aggregation: sum)
   * @param revenueNew (time dependent; aggregation: sum)
   */
  function SelloutImpactRecord(id, releaseId, categoryId, reopen, selloutProductsCount, sitesCount, priceChangesCount, discountPercent, marginOld, marginOldPercent, marginNew, marginNewPercent, marginChange, marginChangePercent, profitOld, profitOldPercent, profitNew, profitNewPercent, profitImpact, profitImpactPercent, minPriceChangeInPercent, maxPriceChangeInPercent, minMarginChangeInPercent, availableSupplyPrice, availableSupply, availableSupplyBeforeRepricingPrice, availableSupplyBeforeRepricing, availableSupplyPriceChange, availableSupplyChange, availableSupplyPriceChangePercent, availableSupplyChangePercent, deadstockProvisionDiscountPercent, deadstockProvision, deadstockInvestment, deadstockImpact, estimationInPercent, // Quantity (volumes)
  salesVolumeOld, salesVolumeNew, // Sales (revenues)
  revenueOld, revenueNew) {
    var _this;

    _classCallCheck(this, SelloutImpactRecord);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SelloutImpactRecord).call(this));
    _this.id = id;
    _this.releaseId = releaseId;
    _this.categoryId = categoryId;
    _this.reopen = reopen;
    _this.selloutProductsCount = selloutProductsCount;
    _this.sitesCount = sitesCount;
    _this.priceChangesCount = priceChangesCount;
    _this.discountPercent = discountPercent;
    _this.marginOld = marginOld;
    _this.marginOldPercent = marginOldPercent;
    _this.marginNew = marginNew;
    _this.marginNewPercent = marginNewPercent;
    _this.marginChange = marginChange;
    _this.marginChangePercent = marginChangePercent;
    _this.profitOld = profitOld;
    _this.profitOldPercent = profitOldPercent;
    _this.profitNew = profitNew;
    _this.profitNewPercent = profitNewPercent;
    _this.profitImpact = profitImpact;
    _this.profitImpactPercent = profitImpactPercent;
    _this.minPriceChangeInPercent = minPriceChangeInPercent;
    _this.maxPriceChangeInPercent = maxPriceChangeInPercent;
    _this.minMarginChangeInPercent = minMarginChangeInPercent;
    _this.availableSupplyPrice = availableSupplyPrice;
    _this.availableSupply = availableSupply;
    _this.availableSupplyBeforeRepricingPrice = availableSupplyBeforeRepricingPrice;
    _this.availableSupplyBeforeRepricing = availableSupplyBeforeRepricing;
    _this.availableSupplyPriceChange = availableSupplyPriceChange;
    _this.availableSupplyChange = availableSupplyChange;
    _this.availableSupplyPriceChangePercent = availableSupplyPriceChangePercent;
    _this.availableSupplyChangePercent = availableSupplyChangePercent;
    _this.deadstockProvisionDiscountPercent = deadstockProvisionDiscountPercent;
    _this.deadstockProvision = deadstockProvision;
    _this.deadstockInvestment = deadstockInvestment;
    _this.deadstockImpact = deadstockImpact;
    _this.estimationInPercent = estimationInPercent;
    _this.salesVolumeOld = salesVolumeOld;
    _this.salesVolumeNew = salesVolumeNew;
    _this.revenueOld = revenueOld;
    _this.revenueNew = revenueNew;
    return _this;
  }

  _createClass(SelloutImpactRecord, null, [{
    key: "initial",
    value: function initial(releaseId, categoryId) {
      return new SelloutImpactRecord(utils_1.Utils.VOID_ID, releaseId, categoryId, null, 0, 0, 0, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null);
    }
  }]);

  return SelloutImpactRecord;
}(DomainObject_1.DomainObject);

exports.SelloutImpactRecord = SelloutImpactRecord;
SelloutImpactRecord.EMPTY = SelloutImpactRecord.initial('', '');

SelloutImpactRecord.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(SelloutImpactRecord.name);
  return {
    id: builder.id('id'),
    releaseId: builder.str('releaseId'),
    categoryId: builder.str('categoryId'),
    reopen: builder.opt(builder.num('reopen')),
    selloutProductsCount: builder.num('selloutProductsCount'),
    sitesCount: builder.num('sitesCount'),
    priceChangesCount: builder.num('priceChangesCount'),
    discountPercent: builder.opt(builder.bigNum('discountPercent')),
    marginOld: builder.opt(builder.bigNum('marginOld')),
    marginOldPercent: builder.opt(builder.bigNum('marginOldPercent')),
    marginNew: builder.opt(builder.bigNum('marginNew')),
    marginNewPercent: builder.opt(builder.bigNum('marginNewPercent')),
    marginChange: builder.opt(builder.bigNum('marginChange')),
    marginChangePercent: builder.opt(builder.bigNum('marginChangePercent')),
    profitOld: builder.opt(builder.bigNum('profitOld')),
    profitOldPercent: builder.opt(builder.bigNum('profitOldPercent')),
    profitNew: builder.opt(builder.bigNum('profitNew')),
    profitNewPercent: builder.opt(builder.bigNum('profitNewPercent')),
    profitImpact: builder.opt(builder.bigNum('profitImpact')),
    profitImpactPercent: builder.opt(builder.bigNum('profitImpactPercent')),
    minPriceChangeInPercent: builder.opt(builder.bigNum('minPriceChangeInPercent')),
    maxPriceChangeInPercent: builder.opt(builder.bigNum('maxPriceChangeInPercent')),
    minMarginChangeInPercent: builder.opt(builder.bigNum('minMarginChangeInPercent')),
    availableSupplyPrice: builder.opt(builder.bigNum('availableSupplyPrice')),
    availableSupply: builder.opt(builder.bigNum('availableSupply')),
    availableSupplyBeforeRepricingPrice: builder.opt(builder.bigNum('availableSupplyBeforeRepricingPrice')),
    availableSupplyBeforeRepricing: builder.opt(builder.bigNum('availableSupplyBeforeRepricing')),
    availableSupplyPriceChange: builder.opt(builder.bigNum('availableSupplyPriceChange')),
    availableSupplyChange: builder.opt(builder.bigNum('availableSupplyChange')),
    availableSupplyPriceChangePercent: builder.opt(builder.bigNum('availableSupplyPriceChangePercent')),
    availableSupplyChangePercent: builder.opt(builder.bigNum('availableSupplyChangePercent')),
    deadstockProvisionDiscountPercent: builder.opt(builder.bigNum('deadstockProvisionDiscountPercent')),
    deadstockProvision: builder.opt(builder.bigNum('deadstockProvision')),
    deadstockInvestment: builder.opt(builder.bigNum('deadstockInvestment')),
    deadstockImpact: builder.opt(builder.bigNum('deadstockImpact')),
    estimationInPercent: builder.opt(builder.bigNum('estimationInPercent')),
    salesVolumeOld: builder.opt(builder.bigNum('salesVolumeOld')),
    salesVolumeNew: builder.opt(builder.bigNum('salesVolumeNew')),
    revenueOld: builder.opt(builder.bigNum('revenueOld')),
    revenueNew: builder.opt(builder.bigNum('revenueNew'))
  };
}();